'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const ModalDialogContext = React.createContext(void 0);

exports.ModalDialogContext = ModalDialogContext;
//# sourceMappingURL=ModalDialogContext.cjs.js.map
